<app-vente-label-price *ngIf="dossierBien.typeDossier === 'vente'" [vente]="vente" [options]="venteOptions">
</app-vente-label-price>

<app-location-label-price *ngIf="dossierBien.typeDossier === 'location'" [location]="location">
</app-location-label-price>
